'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.applyCustomFilters = applyCustomFilters;
exports.getFilters = getFilters;
exports.default = filterCreator;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filters = {};
var customFiltersApplied = false;

function applyCustomFilters() {
  var configFilters = _bdcoreUtilities.ConfigStore.getConfig('filters', {});

  // const filterNames = _.uniq(
  //   _.map(configFilters, v => v)
  //   .reduce((result, config) => { result.push(...Object.keys(config)); return result; }, []),
  // );


  (0, _keys2.default)(_lodash2.default.get(configFilters, 'all', {})).forEach(function (filterKey) {
    _lodash2.default.map(filters, function (v, key) {
      return key;
    }).forEach(function (ftype) {
      var currentConfig = _lodash2.default.get(filters, ftype + '.' + filterKey);

      if (currentConfig) {
        _lodash2.default.set(filters, ftype + '.' + filterKey, (0, _extends3.default)({}, currentConfig, _lodash2.default.get(configFilters, 'all.' + filterKey, {})));
      }
    });
  });

  var types = _lodash2.default.map(configFilters, function (v, key) {
    return key;
  }).filter(function (key) {
    return key !== 'all';
  });
  types.forEach(function (type) {
    (0, _keys2.default)(_lodash2.default.get(configFilters, '' + type)).forEach(function (filterKey) {
      var currentConfig = _lodash2.default.get(filters, type + '.' + filterKey, {});

      _lodash2.default.set(filters, type + '.' + filterKey, (0, _extends3.default)({}, currentConfig, _lodash2.default.get(configFilters, type + '.' + filterKey, {})));
    });
  });

  customFiltersApplied = true;
}

function getFilters(type) {
  if (!customFiltersApplied) {
    applyCustomFilters();
  }
  return _lodash2.default.get(filters, type, {});
}

function filterCreator(type) {
  return function (name, filterConfig) {
    var currentConfig = _lodash2.default.get(filters, type + '.' + name, {});

    var newFilter = (0, _extends3.default)({}, currentConfig, filterConfig);

    _lodash2.default.set(filters, type + '.' + name, newFilter);

    return newFilter;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Filters/FilterCollection.js
// module id = 7
// module chunks = 0